'use strict';

var EmblaCarousel = require('embla-carousel').default;

/**
 * Updates the visibility of the previous/next arrows based on scroll position
 * @param {Object} emblaApi - The Embla Carousel API instance
 * @param {HTMLElement} prevBtn - The previous button element
 * @param {HTMLElement} nextBtn - The next button element
 */
function updateArrows(emblaApi, prevBtn, nextBtn) {
    if (!emblaApi) return;

    if (prevBtn) {
        if (emblaApi.canScrollPrev()) {
            prevBtn.removeAttribute('disabled');
            prevBtn.classList.remove('is-hidden');
        } else {
            prevBtn.setAttribute('disabled', 'disabled');
            prevBtn.classList.add('is-hidden');
        }
    }

    if (nextBtn) {
        if (emblaApi.canScrollNext()) {
            nextBtn.removeAttribute('disabled');
            nextBtn.classList.remove('is-hidden');
        } else {
            nextBtn.setAttribute('disabled', 'disabled');
            nextBtn.classList.add('is-hidden');
        }
    }
}

/**
 * Updates the mask classes on the track based on scroll position
 * @param {Object} emblaApi - The Embla Carousel API instance
 * @param {HTMLElement} track - The track element to apply mask classes to
 */
function updateMasks(emblaApi, track) {
    if (!emblaApi || !track) return;

    // Remove classes first
    track.classList.remove('hidePrevArrow', 'hideNextArrow');

    // Logic:
    // If CANNOT scroll prev -> we are at start -> hide left mask -> add 'hidePrevArrow'
    // If CANNOT scroll next -> we are at end -> hide right mask -> add 'hideNextArrow'
    // 'hidePrevArrow' means "Hide the mask on the Previous (Left) side"

    if (!emblaApi.canScrollPrev()) {
        track.classList.add('hidePrevArrow');
    }

    if (!emblaApi.canScrollNext()) {
        track.classList.add('hideNextArrow');
    }
}

/**
 * Initializes the filter carousel
 */
function init() {
    var carouselNode = document.querySelector('.qf-carousel');
    if (!carouselNode) return;

    var viewportNode = carouselNode.querySelector('.qf-carousel-track');
    var prevBtn = carouselNode.querySelector('.qf-carousel-arrow--prev');
    var nextBtn = carouselNode.querySelector('.qf-carousel-arrow--next');

    if (!viewportNode) return;

    var options = {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        watchDrag: true
    };

    // eslint-disable-next-line new-cap
    var emblaApi = EmblaCarousel(viewportNode, options);

    // Flag to prevent infinite reInit loop:
    // When we call reInit() to disable drag, Embla fires reInit event again.
    // Without this flag that would recursively call updateDragOptions forever.
    var isDragUpdating = false;

    // Event Listeners for Arrows
    if (prevBtn) {
        prevBtn.addEventListener('click', function () {
            emblaApi.scrollPrev();
        }, false);
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function () {
            emblaApi.scrollNext();
        }, false);
    }

    // Update arrows/masks state
    var onUpdate = function () {
        updateArrows(emblaApi, prevBtn, nextBtn);
        updateMasks(emblaApi, viewportNode);
    };

    /**
     * Checks slidesNotInView and disables drag when all slides are visible.
     * Uses isDragUpdating flag to avoid an infinite reInit loop.
     */
    var updateDragOptions = function () {
        if (isDragUpdating) return;

        // Small delay ensures slidesNotInView() is accurate after layout settles
        setTimeout(function () {
            var hasHiddenSlides = emblaApi.slidesNotInView().length > 0;
            var currentWatchDrag = emblaApi.internalEngine().options.watchDrag;

            // Only reInit if value actually changed - avoids unnecessary reInits
            if (!!currentWatchDrag !== hasHiddenSlides) {
                isDragUpdating = true;
                emblaApi.reInit({
                    dragFree: hasHiddenSlides,
                    watchDrag: hasHiddenSlides
                });
                // Reset flag after the triggered reInit event has fired and settled
                setTimeout(function () {
                    isDragUpdating = false;
                }, 100);
            }
        }, 50);
    };

    emblaApi.on('select', onUpdate);
    emblaApi.on('scroll', onUpdate);

    emblaApi.on('init', function () {
        onUpdate();
        updateDragOptions();
    });

    // reInit fires on window resize (Embla's watchResize is on by default).
    // updateDragOptions is guarded by isDragUpdating so self-triggered reInits are skipped.
    emblaApi.on('reInit', function () {
        onUpdate();
        updateDragOptions();
    });

    // Initial call just in case
    onUpdate();
}

module.exports = {
    init: init
};
